import constants from './constants';

const {
  NAMESPACE,
} = constants;

const UPDATE_SETTINGS = `${NAMESPACE}/UPDATE_SETTINGS` as const;

export default {
  UPDATE_SETTINGS,
};
